<div class="main-container">    
<div class="li-page">

  <div class="li-page-header">
    <h1>Legal Information <span *ngIf="!loading">({{ filteredEntries.length }})</span></h1>
    <button class="add-new-btn" (click)="createNew()" [disabled]="creatingNew">
      <mat-icon>add</mat-icon> Create New
    </button>
  </div>

  <div class="li-toolbar">
    <div class="li-search">
      <mat-icon>search</mat-icon>
      <input type="text" placeholder="Search cases..." [ngModel]="searchQuery" (ngModelChange)="onSearchChange($event)">
    </div>
    <div class="li-status-filter-wrap" #statusFilterWrap>
      <button
        type="button"
        class="li-status-filter"
        (click)="toggleStatusDropdown()"
        [class.open]="statusDropdownOpen"
        aria-haspopup="listbox"
        [attr.aria-expanded]="statusDropdownOpen"
      >
        <span>{{ statusFilter }}</span>
        <mat-icon class="li-status-filter-chevron">expand_more</mat-icon>
      </button>

      <ul class="li-status-dropdown-panel" *ngIf="statusDropdownOpen" role="listbox">
        <li
          *ngFor="let opt of statusOptions"
          class="li-status-dropdown-option"
          [class.selected]="statusFilter === opt"
          role="option"
          [attr.aria-selected]="statusFilter === opt"
          (click)="selectStatus(opt)"
        >
          <span>{{ opt }}</span>
          <mat-icon *ngIf="statusFilter === opt" class="li-status-dropdown-check">check</mat-icon>
        </li>
      </ul>
    </div>
  </div>

  <div class="li-table-card" *ngIf="loading || filteredEntries.length">
    <div class="li-table-scroll">
    <table class="li-table">
      <thead>
        <tr>
          <th>Issue Title</th>
          <th>Issue Type</th>
          <th>Status</th>
          <th>Shared With</th>
          <th>Last Updated</th>
          <th class="li-actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of paginatedEntries">
          <td class="li-issue-title" [class.li-issue-title-empty]="!entry.issue_title">{{ displayIssueTitle(entry) }}</td>
          <td>{{ displayIssueType(entry) }}</td>
          <td>
            <span class="li-badge" [ngClass]="entry.status === 'Completed' ? 'completed' : 'draft'">
              {{ entry.status }}
            </span>
          </td>
          <td class="li-shared-with">
            <ng-container *ngIf="getSharedWith(entry).length; else notShared">
              <span *ngFor="let lawyer of getSharedWith(entry)" class="li-shared-person">
                {{ lawyer.name || lawyer.email || lawyer }}
              </span>
            </ng-container>
            <ng-template #notShared>—</ng-template>
          </td>
          <td style="width: 200px;">{{ formatUpdatedAt(entry.updated_at) }}</td>
          <td class="li-actions-col">
            <!-- Completed: View / Share / Delete. Draft: Continue editing / Delete only —
                 this ng-container previously had no *ngIf, so #draftActions was dead code
                 and every row (including drafts) always showed View/Share/Delete. -->
            <ng-container *ngIf="entry.status === 'Completed'; else draftActions">
              <button class="li-icon-btn" title="View" (click)="view(entry)">
                <mat-icon>visibility</mat-icon>
              </button>
              <button class="li-icon-btn" title="Share" (click)="share(entry)">
                <mat-icon>share</mat-icon>
              </button>
              <button class="li-icon-btn danger" title="Delete" (click)="delete(entry)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
            <ng-template #draftActions>
              <button class="li-icon-btn" title="Continue editing" (click)="edit(entry)">
                <mat-icon>edit</mat-icon>
              </button>
              <button class="li-icon-btn danger" title="Delete" (click)="delete(entry)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-template>
          </td>
        </tr>

        <tr *ngIf="loading">
          <td colspan="6" class="li-empty-row">Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>


    <div class="custom-pagination" *ngIf="filteredEntries.length > 0">
      <div class="pagination-info">
        <span class="showing-text">
          Showing
          <strong>{{ getStartIndex() + 1 }}</strong>
          to
          <strong>{{ getEndIndex() }}</strong>
          of
          <strong>{{ filteredEntries.length }}</strong>
          entries
        </span>
      </div>

      <div class="pagination-controls">
        <div class="pagination-buttons">
          <button class="page-btn first-last-btn" (click)="goToFirstPage()" [disabled]="currentPage === 0" title="First page">
            <i class="bi bi-chevron-bar-left"></i>
          </button>
          <button class="page-btn prev-next-btn" (click)="goToPreviousPage()" [disabled]="currentPage === 0" title="Previous page">
            <i class="bi bi-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button *ngFor="let page of getVisiblePages()" class="page-btn page-number-btn"
              [class.active]="page === currentPage" [class.ellipsis]="page === -1"
              (click)="page !== -1 && goToPage(page)" [disabled]="page === -1">
              {{ page === -1 ? '...' : page + 1 }}
            </button>
          </div>

          <button class="page-btn prev-next-btn" (click)="goToNextPage()" [disabled]="currentPage >= getTotalPages() - 1" title="Next page">
            <i class="bi bi-chevron-right"></i>
          </button>
          <button class="page-btn first-last-btn" (click)="goToLastPage()" [disabled]="currentPage >= getTotalPages() - 1" title="Last page">
            <i class="bi bi-chevron-bar-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

 
 <div class="li-empty-state" *ngIf="!loading && !filteredEntries.length">
  <div class="li-empty-illustration">
    <img
      src="assets/images/legalinfoemptyui.png"
      alt="No Legal Information"
      class="docimg"
    />
  </div>

  <h2 class="li-empty-title">
    {{ entries.length ? 'No matching entries' : 'No Legal Information Yet' }}
  </h2>

  <p class="li-empty-subtitle" *ngIf="!entries.length">
    Create and save your case details in one secure place.<br>
    You can continue later or share it with your lawyer when you're ready.
  </p>

  <p class="li-empty-subtitle" *ngIf="entries.length">
    Try adjusting your search or status filter.
  </p>

  <button
    class="li-empty-cta"
    *ngIf="!entries.length"
    (click)="createNew()"
    [disabled]="creatingNew"
  >
    <mat-icon>add</mat-icon>
    Create Legal Information
  </button>

  <!--
  <div class="li-empty-hint" *ngIf="!entries.length">
    Not sure what to enter?
    <a href="javascript:void(0)" (click)="viewSample()">
      View a sample
      <mat-icon class="li-empty-hint-icon">open_in_new</mat-icon>
    </a>
  </div>
  -->
</div>

</div>
</div>